import { keys as parentKeys } from '@copro/api';
import { keys as subTopicKeys } from '../../topics/api/keys';

export const keys = {
  all: [...parentKeys.all, 'events'] as const,

  lists: () => [...subTopicKeys.lists()] as const,

  detail: (id: string) => [...parentKeys.all, 'events', 'detail', id] as const,

  eventDocuments: (eventId: string) => [...keys.detail(eventId), 'documents'] as const,

  upcoming: (spaceId: string) => [...parentKeys.all, 'events', 'upcoming', spaceId] as const,

  bySubTopicId: (subTopicId: string) => [...keys.all, 'bySubTopic', subTopicId] as const,
};
